export const RENDER_CONSTS = {
    ROW_HEIGHT: 28,
    LANES_Y_OFFSET: 30
}